import React from "react";
import { useParams, Link } from "react-router-dom";
import {
  Grid,
  Box,
  Container,
  Typography,
  Breadcrumbs,
} from "@material-ui/core";
import Footer from "../footer/Footer";
import StepperPayment from "../shared/stepperPayment/stepperPayment";
import PaymentMethod from "../shared/paymentMethod/paymentMethod";
import YourInvestment from "../shared/yourInvestment/yourInvestment";
import Form from "./form";
import {
  BillingDetailLogic,
  validator,
  useStyles,
  BillingDetailService,
} from "./billingDetail.module";
import { NavigateNext } from "@material-ui/icons";
import { ProjectDetailService } from "../ProjectDetail/projectDetail.module";
import { DashboardService } from "../dashboard/dashboard.module";

export default function BillingDetail() {
  const { id } = useParams();
  const classes = useStyles();
  const service = BillingDetailService();
  const service_for_project = ProjectDetailService();
  const service_for_user = DashboardService();

  const {
    errors,
    values,
    activeStep,
    steps,
    data,
    onHandleChange,
    handleNext,
    handleBack,
    handleReset,
    handleSubmit,
    translator,
  } = BillingDetailLogic(
    () => console.log("formulario enviado"),
    validator,
    () => service.getTransaction(id),
    service_for_project.getProject,
    service_for_user.getUser
  );

  const props = {
    errors,
    values,
    handleSubmit,
    handleNext,
    handleBack,
    handleReset,
    onHandleChange,
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <Box>
            <Form {...props} />
          </Box>
        );
      case 1:
        return (
          <Box>
            <PaymentMethod
              id={id}
              available={data.user.availableUSD}
              total={values.transaction.total}
              type={values.transaction.type}
              transaction={values.transaction}
              handleBack={handleBack}
            />
          </Box>
        );
      case 2:
        return "";
      default:
        return "Unknown step";
    }
  }

  return (
    <>
      <Box className={classes.breadcrumbContainer}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link className={classes.customLink} to="/">
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_home")}
            </Typography>
          </Link>
          <Link className={classes.customLink} to="/projects">
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_projects")}
            </Typography>
          </Link>
          <Link
            className={classes.customLink}
            to={`/investment/${values.project.id}`}
          >
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_product_selection")}
            </Typography>
          </Link>
          <Link className={classes.customLink} to={`/billing/${id}`}>
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_payment")}
            </Typography>
          </Link>
        </Breadcrumbs>
      </Box>
      <div className={classes.pageContainer}>
        <div className={classes.bgGlowTop} />
        <div className={classes.bgGlowBottom} />

        <Container maxWidth="lg" className={classes.mainContent}>
          <StepperPayment activeStep={activeStep} steps={steps} />

          <Grid container spacing={8} className={classes.contentGrid}>
            <Grid item xs={12} md={7} lg={8}>
              {activeStep === steps.length ? (
                <div />
              ) : (
                <div>{getStepContent(activeStep)}</div>
              )}
            </Grid>

            <Grid item xs={12} md={5} lg={4}>
              <YourInvestment {...values} />
            </Grid>
          </Grid>
        </Container>
      </div>
      <Footer />
    </>
  );
}
